export default __webpack_public_path__ + "static/media/background.1d5602ed.jpg";